<template>
  <div>
    <div
      style="padding-bottom: 50px"
      class="menuShowTabClassSelect"
      :class="{ hidden: hideMenu }"
    >
      <RouterLink to="/home" class="ChildHomeBox">
        <VsxIcon
          iconName="Home"
          :size="28"
          :color="$route.path == '/home' ? '#0096c7' : '#212121'"
          :type="$route.path == '/home' ? 'bold' : 'linear'"
        />
        <span
          class="linkTitle"
          :style="$route.path == '/home' ? 'color:#0096c7' : 'color:#212121'"
          >خانه</span
        >
      </RouterLink>

      <RouterLink
        to="/bookmark"
        class="ChildHomeBox"
        v-if="$store.state.auth.loggedIn"
      >
        <VsxIcon
          iconName="Save2"
          :size="28"
          :color="$route.path == '/bookmark' ? '#0096c7' : '#212121'"
          :type="$route.path == '/bookmark' ? 'bold' : 'linear'"
        />
        <span
          class="linkTitle"
          :style="
            $route.path == '/bookmark' ? 'color:#0096c7' : 'color:#212121'
          "
          >ذخیره</span
        >
      </RouterLink>

      <div
        v-if="!$store.state.auth.loggedIn"
        @click="ShowLoginBoxes = true"
        class="ChildHomeBox"
      >
        <VsxIcon
          iconName="HeartSearch"
          :size="28"
          color="#212121"
          type="linear"
        />
        <span class="linkTitle">ذخیره</span>
      </div>

      <div
        v-if="!$store.state.auth.loggedIn"
        @click="ShowLoginBoxes = true"
        class="ChildHomeBox"
      >
        <div class="menubarHighlight">
          <VsxIcon iconName="Add" :size="56" color="#fff" type="linear" />
        </div>
        <span class="homeLinkTitle">ثبت آگهی</span>
      </div>

      <div
        v-if="$store.state.auth.loggedIn && $store.state.auth.role != 'builder'"
        @click="openComponent('CreateMelk')"
        class="ChildHomeBox"
      >
        <div class="menubarHighlight">
          <VsxIcon iconName="Add" :size="56" color="#fff" type="linear" />
        </div>
        <span class="homeLinkTitle">ثبت آگهی</span>
      </div>
      <div
        v-if="$store.state.auth.loggedIn && $store.state.auth.role == 'builder'"
        @click="openComponent('CreateProject')"
        class="ChildHomeBox"
      >
        <div class="menubarHighlight">
          <VsxIcon iconName="Add" :size="56" color="#fff" type="linear" />
        </div>
        <span class="homeLinkTitle">ثبت پروژه</span>
      </div>

      <RouterLink to="/map-house?main_cat=all&cat=all" class="ChildHomeBox">
        <VsxIcon
          iconName="Map1"
          :size="28"
          :color="$route.path == '/map-house' ? '#0096c7' : '#212121'"
          :type="$route.path == '/map-house' ? 'bold' : 'linear'"
        />
        <span
          class="linkTitle"
          :style="
            $route.path == '/map-house' ? 'color:#0096c7' : 'color:#212121'
          "
          >نقشه</span
        >
      </RouterLink>
      <div
        v-if="$store.state.auth.loggedIn"
        @click="changeRouteHandler"
        class="ChildHomeBox"
      >
        <VsxIcon
          iconName="UserEdit"
          :size="28"
          :color="
            $route.path == '/profile' || $route.path == '/profile-personal' || $route.path == '/user-profile'
              ? '#0096c7'
              : '#212121'
          "
          :type="
            $route.path == '/profile' || $route.path == '/profile-personal' || $route.path == '/user-profile'
              ? 'bold'
              : 'linear'
          "
        />
        <Span
          class="linkTitle"
          :style="$route.path == '/profile' ? 'color:#0096c7' : 'color:#212121'"
          >پروفایل</Span
        >
      </div>
      <div
        v-if="!$store.state.auth.loggedIn"
        @click="ShowLoginBoxes = true"
        class="ChildHomeBox"
      >
        <VsxIcon iconName="UserEdit" :size="28" color="#212121" type="linear" />
        <span class="linkTitle">پروفایل</span>
      </div>
    </div>
    <create-melk
      @close="closeComponent('CreateMelk')"
      v-if="left_menu.CreateMelk"
    ></create-melk>
    <LoginUser @close="ShowLoginBoxes = false" v-if="ShowLoginBoxes" />
  </div>
</template>

<script>
import { toast } from "vue3-toastify";
import createMelk from "@/components/profile/createMelk.vue";
import LoginUser from "@/views/LoginUser";
export default {
  name: "menuBar",
  components: {
    LoginUser,
    createMelk,
  },
  data() {
    return {
      ShowLoginBoxes: false,
      isBackAction: false,
      left_menu: {
        CreateMelk: false,
      },
      branchInfo: null,
    };
  },
  computed: {
    hideMenu() {
      return (
        this.$route.path == "/details" ||
        this.$route.path == "/category" ||
        this.$route.path == "/news" ||
        this.$route.path == "/news-details" ||
        this.$route.path == "/amlak-region" ||
        this.$route.path == "/amlak-list"
      );
    },
  },
  methods: {
    openComponent(menuKey) {
      if (menuKey == 'CreateMelk') {
        if (!this.$store.state.auth.loggedIn) {
          toast('برای ثبت آگهی وارد حساب کاربری خود شوید', {
            type: 'error'
          })
          return;
        } if(this.$store.state.auth.role == 'customer') {
          if (this.$store.state.auth.loggedIn && !this.$store.state.auth.is_complate) {
            toast('برای ثبت آگهی اطلاعات پروفایل خود را تکمیل کنید', {
              type: 'error'
            })
            return;
          }
        } else if(this.$store.state.auth.role == 'builder') {
          if (this.$store.state.auth.loggedIn && !this.$store.state.auth.is_complate) {
            toast('برای ثبت آگهی اطلاعات پروفایل خود را تکمیل کنید', {
              type: 'error'
            })
            return;
          } if (this.$store.state.auth.loggedIn && this.$store.state.auth.is_complate && this.$store.state.auth.is_allowed == 'no') {
            toast('پروفایل شما تکمیل شده است، اما برای ثبت آگهی نیاز است هویت شما تایید شود.', {
              type: 'error'
            })
            return;
          }
        } else if(this.$store.state.auth.role == 'branch_admin') {
          if (this.$store.state.auth.loggedIn && !this.$store.state.auth.is_complate) {
            toast('برای ثبت آگهی اطلاعات پروفایل خود را تکمیل کنید', {
              type: 'error'
            })
            return;
          } if (this.$store.state.auth.loggedIn && this.branchInfo && this.branchInfo.is_allowed != 'active') {
            toast('پروفایل شما تکمیل شده است، اما برای ثبت آگهی نیاز است هویت شما تایید شود.', {
              type: 'error'
            })
            return;
          }
        } else if(this.$store.state.auth.role == 'consultant') {
          if (this.$store.state.auth.loggedIn && !this.$store.state.auth.is_complate) {
            toast('برای ثبت آگهی اطلاعات پروفایل خود را تکمیل کنید', {
              type: 'error'
            })
            return;
          }
        }
      } else if(menuKey == 'CreateProject') {
        if (!this.$store.state.auth.loggedIn) {
          toast('برای ثبت پروژه وارد حساب کاربری خود شوید', {
            type: 'error'
          })
          return;
        } if(this.$store.state.auth.role != 'builder') {
          toast('ثبت پروژه تنها برای کاربر سازنده ممکن است.', {
            type: 'error'
          })
          return;
        } else if(this.$store.state.auth.role == 'builder') {
          if (this.$store.state.auth.loggedIn && !this.$store.state.auth.is_complate) {
            toast('برای ثبت پروژه اطلاعات پروفایل خود را تکمیل کنید', {
              type: 'error'
            })
            return;
          } if (this.$store.state.auth.loggedIn && this.$store.state.auth.is_allowed == 'no') {
            toast('پروفایل شما تکمیل شده است، اما برای ثبت پروژه نیاز است هویت شما تایید شود.', {
              type: 'error'
            })
            return;
          }
        }
      }
      if (menuKey == 'CreateProject') {
        this.$router.push('/builder-create-post')
      } else {
        this.$router.push('/submit-house?step=1')
        // this.left_menu[menuKey] = true;
        // history.pushState(null, "", location.href);
        document.body.style.overflowY = "hidden";
      }
    },
    closeComponent(menuKey) {
      if (!this.isBackAction) {
        history.back();
      }
      this.left_menu[menuKey] = false;
      document.body.style.overflowY = "auto";
    },
    handleBackButton() {
      const isAnyOpen = Object.values(this.left_menu).some(
        (val) => val === true
      );
      if (isAnyOpen) {
        this.isBackAction = true;
        Object.keys(this.left_menu).forEach((key) => {
          this.left_menu[key] = false;
        });
        document.body.style.overflowY = "auto";
        this.isBackAction = false;
      }
    },
    changeRouteHandler() {
      let role = this.$store.state.auth.role;
      role == "customer"
        ? this.$router.push({ path: "/user-profile" })
        : role == "builder"
        ? this.$router.push({ path: "/user-profile" })
        : this.$router.push({ path: "/profile" });
    },
  },
  mounted() {

    const bInfo = localStorage.getItem('branchinof');
    if (bInfo) {
      this.branchInfo = JSON.parse(bInfo);
    }

    window.addEventListener("popstate", this.handleBackButton);
  },
  beforeMount() {
    window.addEventListener("popstate", this.handleBackButton);
  },
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 1100px) {
  .menuShowTabClassSelect {
    border-radius: 0 !important;
    background: #fff;
    box-shadow: 0 0 11px rgba(0, 0, 0, 0.15);
    height: 66px;
    padding-top: 8px;

    &.hidden {
      display: none !important;
    }

    .ChildHomeBox {
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
  }
}

.homeLinkTitle {
  position: absolute;
  right: 0;
  left: 0;
  margin: 0 auto;
  bottom: -30px;
  color: #0096c7;
  font-family: "iranyekanB", sans-serif;
  font-size: 0.785rem;
}

.linkTitle {
  margin-top: 4px;
}
</style>
